import {useEffect, useState} from 'react';
import useServices from './use-services';

const useGeofenceNames = () => {
    const {geofenceService} = useServices();
    const [geofenceNames, setGeofenceNames] = useState({});

    useEffect(() => {
        (async () => {
            const geofences = await geofenceService.list();
            setGeofenceNames(Object.fromEntries(geofences.map((g) => [g.id, g.name])));
        })();
    }, []);

    return geofenceNames;
};

export default useGeofenceNames;
